const ERROR_KEY_LABELS: Record<string, string> = {
  'activity_modifications.new_unit_price': 'Valor unitário',
  'activity_modifications.new_warranty_in_days': 'Garantia em dias',
  'piece_modifications.new_unit_price': 'Valor unitário',
  'piece_modifications.new_warranty_in_days': 'Garantia em dias',
  start_at: 'Data e hora sugerida',
  deadline_to_complete_in_days: 'Prazo em dias',
}

export const updateExecutionEntryErrorsTransformer = (errors: Record<string, string[]>) => {
  const seen = new Set<string>()
  const result: { _base: string[] }[] = []

  Object.entries(errors).forEach(([key, values]) => {
    if (key === 'base') return

    const valueArray = Array.isArray(values) ? values : [String(values)]
    const label = ERROR_KEY_LABELS[key]

    valueArray.forEach((value) => {
      const message = label ? `${label} ${value}` : value

      if (seen.has(message)) return

      seen.add(message)
      result.push({ _base: [message] })
    })
  })

  return result
}
